import Input from './Input'
import InputTextarea from './Textarea'
import InputDate from './Date'

Input.Textarea = InputTextarea
Input.Date = InputDate

export default Input
